require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-first-credit-union-in-indiana-to-launch-buy-now-pay-later-solution.json") })
        }
      }, "path---articles-first-credit-union-in-indiana-to-launch-buy-now-pay-later-solution");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-first-credit-union-in-indiana-to-launch-buy-now-pay-later-solution!./.cache/json/articles-first-credit-union-in-indiana-to-launch-buy-now-pay-later-solution.json
// module id = 1690
// module chunks = 231608221292675